import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useCallback } from 'react';
import { DataGrid } from './data-table.styles';

const DataTable = ({
    rows,
    columns,
    autoRowHeight,
    rowsSelectedIds,
    noRowSelection,
    onRowSelected,
}: {
    rows: GridRowsProp;
    columns: GridColDef[];
    autoRowHeight?: boolean;
    rowsSelectedIds?: string[];
    noRowSelection?: boolean;
    onRowSelected: (row: any) => void;
}) => {
    const getRowSpacing = useCallback(() => {
        return {
            top: 5,
            bottom: 5,
        };
    }, []);

    return (
        <DataGrid
            sx={{ border: 'none' }}
            getRowHeight={() => (autoRowHeight ? 'auto' : 52)}
            getRowClassName={(params) =>
                (params.row.status != null
                    ? `row-status-${params.row.status}`
                    : 'row-no-status') +
                (rowsSelectedIds?.includes(params.row.id)
                    ? ' row-selected'
                    : '')
            }
            hideFooter
            rows={rows}
            columns={columns}
            onRowClick={(params) => onRowSelected(params.row)}
            rowSelection={!noRowSelection}
            disableColumnMenu
            disableColumnFilter
            disableColumnResize
            localeText={{
                noRowsLabel: 'Nessun dato',
            }}
            getRowSpacing={getRowSpacing}
        />
    );
};

export default DataTable;
